import { AdornedInput, IconClockOutline, Input } from '@zillow/constellation';
import type Constellation from '@zillow/constellation';
import { StyledTimeInputAdornment } from './StyledComponents';
type ComboboxInputProps = Constellation.ComboboxInputProps;

const AdornedComboboxInput = (inputProps: ComboboxInputProps) => (
  <AdornedInput
    input={<Input {...inputProps} />}
    rightAdornment={
      <StyledTimeInputAdornment>
        <IconClockOutline size="sm" />
      </StyledTimeInputAdornment>
    }
  />
);

export default AdornedComboboxInput;
